import { AfterViewInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ICON_TYPE, PageSlotComponent, IconComponent } from '@spartacus/storefront';
import { UserAccountFacade } from '@spartacus/user/account/root';
import { Subscription } from 'rxjs';
import { NgClass } from '@angular/common';

@Component({
    selector: 'knbr-kn-br-sales-landing',
    templateUrl: './kn-br-sales-landing.component.html',
    styleUrls: ['./kn-br-sales-landing.component.scss'],
    imports: [PageSlotComponent, IconComponent, NgClass]
})
export class KnBrSalesLandingComponent implements OnInit, AfterViewInit {
  slideIndex = 1;
  totalSlides = 0;
  dots = [];
  previousIcon = ICON_TYPE.CARET_LEFT;
  nextIcon = ICON_TYPE.CARET_RIGHT;
  subscription = new Subscription();
  user$ = this.userService.get();
  userName: string = '';

  constructor(private cdr: ChangeDetectorRef, private userService: UserAccountFacade) {
    this.subscription.add(
      this.user$.subscribe((user: any) => {
        if (user) {
          this.userName = user.firstName;
        }
      })
    );
  }

  ngOnInit(): void {}

  ngAfterViewInit(): void {
    setTimeout(() => {

    const slides = document.getElementsByClassName('mySlides');
    if (slides.length) {
      //@ts-ignore
      for (let slide of slides) {
        if (slide.getAttribute('data-visiblae') === 'false') {
          slide.parentElement.removeChild(slide);
        }
      }
      //@ts-ignore
      for (let slide of slides) {
        if (slide.innerHTML.indexOf('Product Spotlight') > -1) {
          this.dots.push('slide');
        }
      }
    }
    if (this.dots.length) {
      this.totalSlides = this.dots.length;
      this.showSlide(1);
      this.cdr.detectChanges();
    }
    }, 2000);
  }

  plusSlides(n: number) {
    this.showSlide((this.slideIndex += n));
  }

  showSlide(n: number) {
    let i;
    let slides = document.getElementsByClassName('mySlides');
    let dots = document.getElementsByClassName('dot');
    if (n > slides.length) {
      this.slideIndex = 1;
    }
    if (n < 1) {
      this.slideIndex = slides.length;
    }
    for (i = 0; i < slides.length; i++) {
      //@ts-ignore
      slides[i].style.display = 'none';
    }
    for (i = 0; i < dots.length; i++) {
      dots[i].className = dots[i].className.replace(' active', '');
    }
    if (slides.length) {
      //@ts-ignore
      slides[this.slideIndex - 1].style.display = 'block';
      //@ts-ignore
      slides[this.slideIndex - 1].style.opacity = '1';
    }
    if (dots.length) {
      dots[this.slideIndex - 1].className += ' active';
    }
  }

  currentSlide(n) {
    this.showSlide((this.slideIndex = n));
  }

   ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }
}
